import { isMapMode } from '../maps/util';
import { updateURLs } from '../url';
import { removeElements } from '../dom/remove';
import { getState } from '../routing/history';

function onSaveChangeHandleViewMode( event ) {
    if ( !event.detail.saved || isMapMode() ) {
        return;
    }

    const mapSearchEl = document.querySelector( '#twc__map-search-map' );

    if ( !mapSearchEl ) {
        return;
    }

    mapSearchEl.dataset.mapSearchViewMode = '';

    const newURL = new URL( window.location.href );
    newURL.searchParams.delete( 'viewmode' );

    window.router.Replace( 'current', Object.assign( {}, getState(), {
        url: newURL.toString(),
    } ) );

    updateURLs( '#currency-mobile a', 'returnUrl', `${newURL.pathname}?${newURL.searchParams.toString()}` );

    updateURLs( '#language-mobile a', 'returnUrl', `${newURL.pathname}?${newURL.searchParams.toString()}` );

    updateURLs( '.header__currencychange a', 'returnUrl', `${newURL.pathname}?${newURL.searchParams.toString()}` );

    removeElements( 'input[name=viewmode]' );
}

export {
    onSaveChangeHandleViewMode,
};
